module.exports = new __parcel__URL__("email_icon.6ea686eb.svg").toString();